var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#1F1B16"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F4EFE6",
    fillRule: "evenodd",
    d: "M30 18a7 7 0 0 1 14 0V70L37 98L30 70Z M37 9.6a2.1 2.1 0 0 0-2.1 2.1v9.4a2.1 2.1 0 0 0 4.2 0v-9.4A2.1 2.1 0 0 0 37 9.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#D9AFC6",
    strokeWidth: 5.4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M37 16C90 2 94 58 44 56C62 58 64 76 76 86C86 94 98 84 90 75C83 68 72 78 80 88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkDark);
export default __webpack_public_path__ + "static/media/mark-dark.3eaccf740966b2977f017996d5774504.svg";
export { ForwardRef as ReactComponent };